import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest } from "../../../api/controller/PermitTypeController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const permitTypeListState = atom({
    key: 'permitTypeListState',
    default: [],
})


export const modalConfigDefault = { size: "md", wizard: false }

export const permitTypeFilterState = selector({
    key: 'permitTypeFilterState',
    get: () => ([])
})


export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const permitTypeDataStructureState = selector({
    key: 'permitTypeDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Name',
                type: 'text',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Duration',
                type: 'number',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }, subText: 'days' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Minimum Balance',
                type: 'number',
                order: { table: 3, form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }, subText: 'for Docking and Mooring' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Price',
                type: 'number',
                order: { table: 3.1, form: 3.1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Tax Rate',
                type: 'number',
                order: { table: 3.2, form: 3.2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }, subText: "in decimals. eg: 0.08 for 8%" }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Active',
                type: 'switch',
                order: { table: 4, form: 4 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: ['Yes', 'No'],
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
